import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type PathNavigatorProps = {
  path: string;
};

function PathNavigator({ path }: PathNavigatorProps) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate({ pathname: path, search: location.search, hash: location.hash }, { replace: true });
  }, [navigate, path, location.search, location.hash]);

  return null;
}

export default PathNavigator;
